import { makeStyles, createStyles } from "@mui/styles";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

const useStyles = makeStyles((theme) =>
  createStyles({
    list: {
      margin: 0,
      padding: 0,
    },
    listItem: {
      padding: 0,
    },
    name: {
      fontSize: 11,
    },
    unit: {
      fontSize: 10,
      minWidth: 36,
    },
  })
);

const MealItem = ({ item }) => {
  const { dish: { name } = {}, amount, unit } = item;
  const { sign } = unit || {};
  const classes = useStyles();

  const sign2 = (sign || "").substring(0, 3);

  return (
    <ListItem className={classes.listItem}>
      <ListItemIcon className={classes.unit}>
        {amount}
        {sign2}
      </ListItemIcon>
      <ListItemText
        primary={<Typography className={classes.name}>{name}</Typography>}
      />
    </ListItem>
  );
};

const Meal = ({ data = [] }) => {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      {data.map((item) => (
        <MealItem key={`item-${item.id}`} item={item} />
      ))}
    </List>
  );
};

export default Meal;
